import React from 'react';
import classnames from 'classnames';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { right } from 'scy/utils.mod.scss';
import { H5 } from 'scy/text';
import { fontSizeS, secondary, sansSerifLight } from 'scy/text/styles.mod.scss';
import { ThumbnailProductImage } from 'scy/ProductImage';
import styles from './styles.mod.scss';

export default function ProductRow({
  product,
  quantity,
  className,
  showPrice = false
}) {
  return (
    <div
      className={classnames(
        padding.top_xs,
        padding.bottom_xs,
        margin.left_xs,
        margin.right_xs,
        className
      )}
    >
      <ThumbnailProductImage product={product} className={styles.thumbnail} />
      <div className={styles.receiptProductInfo}>
        <H5 uppercase tag="div" className={`${right} ${margin.left_xs}`}>
          {quantity}
        </H5>
        <H5 uppercase tag="div">
          {product.title}
        </H5>
        <div className={classnames(fontSizeS, secondary, sansSerifLight)}>
          {product.subtitle}
        </div>
        {showPrice && (!!product.subtotal || !!product.discount_price) && (
          <H5 uppercase tag="div" className={`${right} ${margin.left_xs}`}>
            {product.subtotal
              ? `$${product.subtotal.toFixed(2)}`
              : `$${(product.discount_price * product.quantity).toFixed(2)}`}
          </H5>
        )}
        <div className={classnames(fontSizeS, secondary, sansSerifLight)}>
          {product.volume}
        </div>
      </div>
    </div>
  );
}
